import { memo } from 'react';
import { Box, Button, SxProps, Typography } from '@mui/material';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import Loader from '../loader';

const ActionOptionLink = memo(
  ({
    title,
    buttonText,
    showButton = true,
    action,
    loading,
    color,
    sx,
    buttonSx = {},
    children,
  }: {
    title: string;
    buttonText: string | ReactJSXElement;
    action?: () => Promise<void> | void;
    showButton?: boolean;
    loading?: boolean;
    color?: string;
    buttonSx?: SxProps;
    sx?: SxProps;
    children?: ReactJSXElement;
  }) => {
    const button = (
      <Button
        variant="text"
        onClick={action}
        disabled={loading}
        sx={{
          backgroundColor: 'transparent',
          padding: '0',
          minWidth: 0,
          borderRadius: 0,
          borderBottom: `1px solid ${color || '#3F906D'}`,
          color,
          ...buttonSx,
        }}
      >
        {buttonText}
      </Button>
    );

    return (
      <Box sx={{ padding: '20px 0', ...sx }}>
        <Typography fontSize={12} color={'rgb(142, 142, 161)'}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex' }}>
          {showButton ? button : children}
          {loading && <Loader size={14} />}
        </Box>
      </Box>
    );
  }
);

export default ActionOptionLink;
